import { type ReactNode } from 'react';

/**
 * Briques communes aux modules Front de Sysaxes : mêmes noms de classes que le
 * module Front / Dolibarr, pour que les deux panneaux partagent une charte.
 */

export function App({ children }: { children: ReactNode }) {
  return <div className="app">{children}</div>;
}

export function Section({ title, aside, children }: { title: string; aside?: ReactNode; children: ReactNode }) {
  return (
    <section className="section">
      <div className="section-header">
        <h2>{title}</h2>
        {aside}
      </div>
      {children}
    </section>
  );
}

export function Banner({
  tone,
  children,
}: {
  tone: 'info' | 'success' | 'warning' | 'error' | 'empty';
  children: ReactNode;
}) {
  return <p className={`banner banner-${tone}`}>{children}</p>;
}

export function Button({
  onClick,
  disabled,
  variant = 'default',
  small,
  title,
  children,
}: {
  onClick: () => void;
  disabled?: boolean;
  variant?: 'default' | 'primary' | 'link';
  small?: boolean;
  title?: string;
  children: ReactNode;
}) {
  const base = variant === 'link' ? 'button-link' : `button${variant === 'primary' ? ' button-primary' : ''}`;
  return (
    <button
      type="button"
      className={`${base}${small ? ' button-small' : ''}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  );
}

export function Spinner({ label }: { label: string }) {
  return <p className="spinner">{label}</p>;
}
